import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import { QueryClient, QueryCache, MutationCache } from 'react-query';
import { HANDLED_ERRORS } from '../components/pages/errors/ErrorScreen';
import handleApiError from './handleApiError';
var queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: function onError(error) {
      return handleApiError(error);
    }
  }),
  mutationCache: new MutationCache({
    onError: function onError(error) {
      return handleApiError(error);
    }
  }),
  defaultOptions: {
    queries: {
      retry: false,
      useErrorBoundary: function useErrorBoundary(error) {
        var is404 = 'status' in error && error.status === 404;
        var isErrorBoundaryError = 'code' in error && typeof error.code === 'string' && HANDLED_ERRORS.includes(error.code);
        return is404 || isErrorBoundaryError;
      }
    }
  }
});
export default queryClient;